// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#track-tab[data-v-6c1a4188]{padding:0 10px 0 10px}`, "",{"version":3,"sources":["webpack://./src/components/TrackMetadataTab.vue"],"names":[],"mappings":"AACA,4BACC,qBAAA","sourcesContent":["\n#track-tab {\n\tpadding: 0 10px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
